import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { ArrowLeft } from 'lucide-react';

const LegalMentions = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: 'var(--bg-color)', minHeight: '100vh', color: 'var(--text-primary)', padding: '2rem 1rem' }}>
      <SEO title="Mentions Légales | Masse-terclass" />
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'var(--bg-card)', padding: '2rem', borderRadius: '12px', border: '1px solid var(--border-color)' }}>
        
        <button className="btn btn-outline" onClick={() => { window.scrollTo(0,0); navigate('/'); }} style={{ marginBottom: '2rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
          <ArrowLeft size={18} /> Retour
        </button>

        <h1 style={{ color: 'var(--primary-color)', marginBottom: '2rem', fontSize: '2.5rem' }}>Mentions Légales</h1>
        
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>1. Éditeur du site</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Le site <strong>Masse-terclass</strong> (masse-terclass.com) est une plateforme personnelle de suivi d'entraînement.<br />
            <strong>Contact :</strong> contact@masse-terclass.com
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>2. Hébergement</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Le site est hébergé par :<br />
            <strong>Infomaniak Network SA</strong><br />
            Rue Eugène-Marziano 25, 1227 Genève - Suisse<br />
            Site Web : <a href="https://www.infomaniak.com" target="_blank" rel="noreferrer" style={{ color: 'var(--primary-color)' }}>www.infomaniak.com</a>
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>3. Propriété intellectuelle</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            L'ensemble de ce site relève des législations françaises et internationales sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents iconographiques et photographiques.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>4. Données personnelles & Firebase</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Ce site utilise <strong>Google Firebase</strong> (Firebase Authentication, Firestore DB) pour la gestion des comptes utilisateurs et la sauvegarde des données d'entraînement. En créant un compte, vous acceptez que vos données d'entraînement, votre adresse e-mail et votre nom soient stockés de manière sécurisée sur les serveurs de Firebase.<br /><br />
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de portabilité et de suppression de vos données. Vous pouvez exercer ce droit à tout moment depuis les paramètres de votre compte ou en nous contactant à <strong>contact@masse-terclass.com</strong>.
          </p>
        </section>
        
        <section>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>5. Cookies</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Ce site utilise uniquement des cookies techniques strictement nécessaires à son fonctionnement (maintien de la connexion sécurisée via Firebase Auth, mémorisation du thème d'affichage). Aucun cookie de ciblage publicitaire ou de tracking à des fins commerciales n'est utilisé.
          </p>
        </section>

      </div>
    </div>
  );
};

export default LegalMentions;
